<template>
    <div class="cf-wrapper">
        <div class="cf-container"  v-if="coordinators.length > 0">
            <draggable 
                tag="div" 
                :list="coordinators" 
                class="form-list-group" 
                handle=".cf-control-handle" 
                v-if="coordinators && coordinators.length > 0" 
                @start="isDragging = true" 
                @end="isDragging = false"
                :animation="200"
                group="coordinators"
                :disabled="false"
                ghostClass="ghost"> 
                <transition-group type="transition" :name="!isDragging ? 'flip-list' : null">
                    <div class="cf-input" v-for="(coordinator, index) in coordinators" :key="index">
                        <div class="cf-control-handle">
                            <i class="fa fa-align-justify"></i>
                        </div>
                        <div class="cf-input-control">
                            <div class="cf-image">
                                <div class="avatar" :style="`background-image: url(${coordinator.image})`"></div>
                            </div>
                            <div class="details">
                                <h6>{{ coordinator.designation }} {{ coordinator.name }} <br> <small>{{ coordinator.title }}</small></h6>
                                <a :href="`tel:${coordinator.phone}`">{{ coordinator.phone }}</a> | <a :href="`mailto:${coordinator.email}`">{{ coordinator.email }}</a>
                            </div>
                        </div>
                        <div class="cf-input-options">
                            <div>
                                <n-button type="warning" size="sm" round icon simple @click.native="editInput(coordinator)">
                                    <i class="fa fa-pencil"></i>
                                </n-button>
                                <n-button type="primary" size="sm" round icon simple @click.native="copyInput(coordinator)">
                                    <i class="now-ui-icons files_single-copy-04"></i>
                                </n-button>
                                <n-button type="danger" size="sm" round icon simple @click.native="deleteInput(coordinator)">
                                    <i class="now-ui-icons ui-1_simple-remove"></i>
                                </n-button>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
            <!-- <div v-for="(coordinator, index) in coordinators" :key="index" >
                
            </div> -->
        </div>
        <div class="cf-creator">
            <div class="row">
                <div class="col-sm-3">
                    <el-upload
                        class="avatar-uploader"
                        name="image"
                        list-type="text"
                        accept="image/jpeg,image/png"
                        :data="{path: 'tukio/coordinators/'}"
                        :action="uploadURL"
                        :headers="headers"
                        :show-file-list="true"
                        :on-success="handleAvatarSuccess"
                        :before-remove="handleRemove"
                        :before-upload="beforeAvatarUpload">
                        <div v-if="model.image" class="avatar" :style="`background-image: url(${model.image})`"></div>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
                <div class="col-sm-9">
                    <div class="row">
                        <div class="col-sm-4">
                            <fg-input
                                type="text"
                                name="designation"
                                label="Salutation"
                                v-validate="modelValidations.designation"
                                :error="getError('designation')"
                                v-model="model.designation">
                                <el-select class="select-primary" placeholder="Select Salutation" v-model="model.designation">
                                    <el-option v-for="(option, index) in salutations" class="select-primary" :value="option" :label="option" :key="index">
                                    </el-option>
                                </el-select>
                            </fg-input>
                        </div>
                        <div class="col-sm-8">
                            <fg-input
                                type="text"
                                required
                                name="name"
                                label="Name"
                                v-validate="modelValidations.name"
                                :error="getError('name')"
                                v-model="model.name"
                                inputClasses="form-control-sm">
                            </fg-input>
                        </div>
                        <div class="col-sm-4">
                            <fg-input
                                type="text"
                                required
                                name="title"
                                label="Title"
                                v-validate="modelValidations.title"
                                :error="getError('title')"
                                v-model="model.title"
                                inputClasses="form-control-sm">
                            </fg-input>
                        </div>
                        <div class="col-sm-4">
                            <fg-input
                                type="text"
                                required
                                name="phone"
                                label="Mobile"
                                v-validate="modelValidations.phone"
                                :error="getError('phone')"
                                v-model="model.phone"
                                inputClasses="form-control-sm">
                            </fg-input>
                        </div>
                        <div class="col-sm-4">
                            <fg-input
                                type="email"
                                required
                                name="email"
                                label="Email"
                                v-validate="modelValidations.email"
                                :error="getError('email')"
                                v-model="model.email"
                                inputClasses="form-control-sm">
                            </fg-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 text-left">
                    <n-button @click.native="saveCoordinators()" type="primary" round> <i class="now-ui-icons ui-1_check"></i> Save Coordinators</n-button>
                </div>
                <div class="col-sm-6 text-right">
                    <n-button @click.native="addToCoordinators()" type="primary" round simple> <i class="now-ui-icons ui-1_simple-add"></i> Add to Coordinators</n-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { FormGroupInput, Card, Button, Checkbox, Radio, Switch } from 'src/components';
import { Upload, Select, Option, Slider, DatePicker, Tag } from 'element-ui';
import draggable from "vuedraggable";
import { mapGetters } from 'vuex';

// https://gist.github.com/codeguy/6684588#gistcomment-2690429
function string_to_slug(str) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaaaeeeeiiiioooouuuunc------";

    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-") // collapse dashes
        .replace(/^-+/, "") // trim - from start of text
        .replace(/-+$/, ""); // trim - from end of text

    return str;
}

export default {
    name: 'CoordinatorForm',
    props:{
        cords: {
            type: Array,
            default: () => []
        }
    },
    components: {
        [Upload.name]: Upload,
        [Select.name]: Select,
        [Option.name]: Option,
        [Switch.name]: Switch,
        [Slider.name]: Slider,
        [DatePicker.name]: DatePicker,
        [Radio.name]: Radio,
        [Checkbox.name]: Checkbox,
        [Tag.name]: Tag,
        [Upload.name]: Upload,
        draggable,
    },
    computed: {
        ...mapGetters({
            salutations: 'getSalutations',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences',
        }),
        
        headers(){
            this.authTokens['content-type'] = 'multipart/form-data'
            let {token, refreshtoken} = this.authTokens
            return {token, refreshtoken};
        },
        uploadURL(){
            return `${process.env.VUE_APP_BASE_URL}/tukio/upload`
        }
    },
    mounted(){
        this.$store.dispatch('getSalutations');
        this.coordinators = this.cords;
    },
    watch: {
        cords(){
            this.coordinators = this.cords
        }
    },
    data(){
        return {
            isDragging: false,
            isEditing: false,
            inputIndex: null,
            coordinators: [],
            model: {
                name: null,
                title: null,
                designation: null,
                image: null,
                phone: null,
                email: null,
            },
            modelValidations: {
                name:{ required: true },
                title:{ required: false },
                designation:{ required: false },
                image:{ required: true },
                phone:{ required: true },
                email:{ required: true, email: true },
            },
        }
    },
    methods: {
        editInput(input){
            this.inputIndex = this.coordinators.indexOf(input)
            this.model = Object.assign({}, input)
            this.deleteInput(input)
            this.isEditing = true
        },
        copyInput(coordinator){
            this.isEditing = false
            this.model = Object.assign({}, coordinator)
        },
        deleteInput(coordinator){
            this.isEditing = false
            this.coordinators.splice(this.coordinators.indexOf(coordinator), 1)
        },
        addToCoordinators(){
            return this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if(!this.isEditing){
                        this.coordinators.push(this.model)
                    }
                    else{
                        this.coordinators.splice(this.inputIndex, 0, this.model);
                    }

                    this.model = {
                        name: null,
                        title: null,
                        designation: null,
                        image: null,
                        phone: null,
                        email: null,
                    }
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                    this.isEditing = false
                    this.inputIndex = null
                }
                return isValid;
            });
        },
        saveCoordinators(){
            this.$emit('on-submit', Object.assign([], this.coordinators));
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        handleRemove(file, fileList){
        this.model.image = null
        },
        handleAvatarSuccess(res, file) {
            this.model.image = res.data.image;
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$notify({
                message: `Cover picture size can not exceed 2MB!`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            })
            }
            return isLt2M;
        }
    }
}
</script>

<style lang="scss" scoped>

.cf-wrapper{
    position: relative;
    height: 90vh;

    .cf-creator{
        position: absolute;
        bottom: 0;

        margin-top: 15px;
        padding: 10px;
        box-shadow: 0px -10px 10px #eeeded;
    }
}

.cf-container{
    height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;

    .cf-input{
        margin: 5px;
        padding: 5px 10px;
        margin-bottom: 15px;
        border: solid 1px #eeeded;
        box-shadow: 0px 2px 3px #eee;
        display: flex;
        align-items: center;
        justify-content: start;

        .cf-control-handle{
            padding: 5px 10px;
            line-height: 50px;
            text-align: center;
            vertical-align: middle;
            cursor: move;
            flex: 0.5;
        }

        .cf-input-control{
            flex: 6;
            display: flex;

            .cf-image{
                overflow: hidden;
                text-align: center;
                flex: 1;

                .avatar{
                    margin: 0 auto;
                    width: 60px;
                    height: 60px;
                    border-radius: 100%;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: top center;
                }
            }

            .details{
                flex: 4;
            }
        }

        .cf-input-options{
            flex: 2;
            text-align: right;

            button{
                margin-right: 5px;
            }
        }
    }
}

.cf-creator{
    margin-top: 15px;
    padding: 10px;
    box-shadow: 0px -10px 10px #eeeded;
}

/* width */
.cf-container::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.cf-container::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px transparent; 
    border-radius: 3px;
}

/* Handle */
.cf-container::-webkit-scrollbar-thumb {
    background: #eee; 
    border-radius: 5px;
}

/* Handle on hover */
.cf-container::-webkit-scrollbar-thumb:hover {
    background: #aaa; 
}

.cf-creator,
.cf-container {
    .form-group label{
        margin-bottom: 0px;
        margin-left: 10px;
    }

    .input-new-tag{
        padding: 10px;
    }
}

.cf-creator .form-control-sm,
.cf-container .form-control-sm {
    height: calc(1.8125rem + 2px);
    padding: .25rem .5rem;
    font-size: .875rem;
    line-height: 1.5;
}
.cf-creator {
    .form-control.input-new-tag{
        width: 250px!important;
        text-align: center;
        display: inline-block;
    }
}

.avatar-uploader .avatar{
    height: 150px;
}
</style>
